import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_CLEARFORMAT } from '@editor/src/img/pageIndex';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.CLEAR_FORMAT,
    tipMsg: i18n.t('清除格式'),
    icon: TOOLBAR_CLEARFORMAT,
    twdConfig: {
        action: TDWActionType.CLEAR_FORMATTING,
        notReportVer5: true,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
    },
];
